<div class="option">
    <ng-content select="[option-header]"></ng-content>
  <hr>
  <div class="option-content">
    <div class="title">
      <ng-content  select="[option-content-title]"></ng-content>
    </div>
    <div class="body">
      <ng-content select="[option-content-body]"></ng-content>
    </div>
  </div>
  <div class="footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
